import React, { useEffect, useState } from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import { ThemeProvider } from "@mui/material/styles";
import theme from "../style/theme.js";
import { apiElementImage } from '../api.js';

const ImageIGLS = (params) => {

    const {id, typeImage} = params

    const [monImage, setMonImage] = useState(null)
    const [loading, setLoading] = useState(true)
    const [erreur, setErreur] = useState(false)

    useEffect(() => {
        apiElementImage(id,typeImage)
        .then(res => {
            console.log(typeof res.reponse)
            if (typeof res.reponse === 'string'){
                setMonImage(new Blob([res.reponse], {type:"image/svg+xml"}))
            } else {
                setMonImage(res.reponse)
            }
            setLoading(false)
        })
        .catch(error => {
            console.log(error)
            setLoading(false)
            setErreur(true)
        })
    }, [id, typeImage])

    const handleClick = () => {
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(monImage);
        a.style.display = 'none';
        a.href = url;
        a.target = "_blank"
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        return
    }

    const afficheImage = () => {
        let tempo = "Image à droit restreint"
        if (monImage){
            tempo = <img src={URL.createObjectURL(monImage)} height="150" alt={id} onClick={handleClick}/>
        }
         return tempo
    }



    return (
        <>
        {loading && <ThemeProvider  theme={theme}><CircularProgress color="secondary"/><h3>Je charge</h3></ThemeProvider> }
        {erreur  && <h3>J'ai rencontré un problème...</h3> }
        {!loading && ! erreur && afficheImage() }
        </>
    )
}

export default ImageIGLS